'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.truncate = exports.uppercase = exports.bold = exports.semibold = exports.regular = exports.light = exports.large = exports.unselectable = exports.link = exports.text = undefined;

var _colors = require('./colors');

var text = exports.text = {
    color: _colors.steel,
    cursor: 'default',
    fontFamily: '"Source Sans Pro", sans-serif',
    fontSize: 14,
    lineHeight: '1.2'
};

var link = exports.link = {
    outline: 'none',
    textDecoration: 'none'
};

var unselectable = exports.unselectable = {
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    MsUserSelect: 'none',
    UserSelect: 'none'

    /* Sizes */

};var large = exports.large = {
    fontSize: 16

    /* Weights */

};var light = exports.light = {
    fontWeight: '300'
};

var regular = exports.regular = {
    fontWeight: '400'
};

var semibold = exports.semibold = {
    fontWeight: '600'
};

var bold = exports.bold = {
    fontWeight: '700'

    /* Utilities */

};var uppercase = exports.uppercase = {
    textTransform: 'uppercase'
};

var truncate = exports.truncate = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
//# sourceMappingURL=typography.js.map